import React, { Component } from 'react';
import { Row, Col, Button } from 'reactstrap';
import { setSectionData } from './helper';
import './style.scss';
class SectionDetailsList extends Component {
    constructor() {
        super();
        this.state = {
            sectionData: []
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.sectionList !== prevProps.sectionList) {
            this.setState({
                sectionData: this.props.sectionList.sort(function (a, b) {
                    var textA = a.rate;
                    var textB = b.rate;
                    return (textA < textB) ? 1 : (textA > textB) ? -1 : 0;
                })
            })
        }
    }
    handleSectionChange = (event, sectionTemplateId) => {
        const tempSectionData = setSectionData(this.state.sectionData, event.target.value, sectionTemplateId)
        this.setState({
            sectionData: tempSectionData
        })
    }
    handleSubmit = () => {
        this.props.sectionDetailsCallback(this.state.sectionData);
        window.scrollTo(0, 0)
    }
    render() {
        return (
            <Col>
                <Row>
                    {
                        this.state.sectionData.map(p => {
                            return (
                                <Col className="col-sm-12 d-flex select-risk-factor py-3" key={p.sectionTemplateId}>
                                    <div className="d-flex risk-factor-details">
                                        <label title={p.sectionTemplateName} className="d-inline-block w-75 px-3 py-2 risk-factor-name text-truncate">{p.sectionTemplateName}</label>
                                        <span className="d-inline-block w-15 text-center curreny-icon text-truncate">₹</span>
                                        <input type="number" value={p.rate} onChange={(event) => this.handleSectionChange(event, p.sectionTemplateId)} name={p.sectionTemplateName} className="w-25 p-1 text-center risk-factor-weight" placeholder="00"></input>
                                    </div>
                                </Col>
                            )
                        })
                    }

                </Row>
                <Row className="float-right">
                    <Button className="btn btn-info" onClick={this.handleSubmit}>OK</Button>
                </Row>
            </Col>
        )
    }
}
export default SectionDetailsList;